import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserContext } from '@hooks/context/useUserContext';
import { EUserRole } from '@xeppt/xeppt-sdk/types';
import { routes } from '@const/routes';

// Mirrors the backend's `role >= Admin` gate for /admin/funds-flow. Backend role values
// (SUPER_ADMIN=99, COMPLIANCE_OFFICER=20, ADMIN=12, CUSTOMER_SERVICE=11, SALES_MANAGER=10,
// REGULAR_USER=1) happen to make ">= Admin" and "one of these three" equivalent sets today,
// but this is an explicit allowlist — like ComplianceGuard/SuperAdminGuard — so the gate
// can't silently widen if a future role is inserted between existing values. Shared with
// the sidebar nav item so the route guard and the nav visibility never drift apart.
export const ADMIN_AND_ABOVE_ROLES: EUserRole[] = [
    EUserRole.ADMIN,
    EUserRole.COMPLIANCE_OFFICER,
    EUserRole.SUPER_ADMIN
];

const AdminAndAboveGuard = () => {
    const { user, isDataLoading } = useUserContext();

    // Hold render until the profile is loaded to avoid bouncing a legitimate admin on a
    // direct deep-link / page refresh, matching ComplianceGuard/SuperAdminGuard.
    if (isDataLoading || !user) {
        return null;
    }

    if (user.role && ADMIN_AND_ABOVE_ROLES.includes(user.role)) {
        return <Outlet />;
    }

    return <Navigate to={routes.transactions} replace />;
};

export default AdminAndAboveGuard;
